exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-descriptions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.search-descriptions ul.tree {\n  padding-left: 0;\n}", ""]);

// exports
